import { shrpaApi } from "./axios";
import type { AtlasSeedResult, AtlasSeedTemplateSummary, SeedAtlasCustomerRequest, SeedFileCopyResult } from "@contracts/testData";

function normalizeSeedResult(data: AtlasSeedResult): AtlasSeedResult {
  return { ...data, notes: data.notes || [], warnings: data.warnings || [], onboardingStep: data.onboardingStep ?? null };
}

export default {
  async getAtlasTemplates(): Promise<AtlasSeedTemplateSummary[]> {
    const { data } = await shrpaApi.get<AtlasSeedTemplateSummary[]>("/admin/test-data/atlas-templates");
    return data;
  },

  /** Seeds a new test customer, or (addToExisting) adds the template's data to an existing test customer. */
  async seedAtlasCustomer(request: SeedAtlasCustomerRequest): Promise<AtlasSeedResult> {
    const { data } = await shrpaApi.post<AtlasSeedResult>("/admin/test-data/atlas-customers", request);
    return normalizeSeedResult(data);
  },

  /** The upload page's "Seed photos": adds the template's albums to the test customer's matching Locations. */
  async seedPhotos(customerId: string, templateKey = "rochestermn"): Promise<AtlasSeedResult> {
    const { data } = await shrpaApi.post<AtlasSeedResult>(`/admin/test-data/atlas-customers/${encodeURIComponent(customerId)}/photos`, null, {
      params: { templateKey },
    });
    return normalizeSeedResult(data);
  },

  /** Copies the template's files that are missing in this environment from the other environment's CDN. Safe to run again. */
  async copyMissingSeedFiles(templateKey: string): Promise<SeedFileCopyResult> {
    const { data } = await shrpaApi.post<SeedFileCopyResult>(`/admin/test-data/atlas-templates/${encodeURIComponent(templateKey)}/copy-missing-files`);
    return { ...data, notFound: data.notFound || [], failedCount: data.failedCount ?? 0 };
  },
};
